export const DEFAULT_LOCALE_CODE = 'en-US';
export const GOLD_COMPANY_ID = '00000000-0000-0000-0000-000000000000';
export const GOLD_COPY_NOT_AVAILABLE_TEXT = 'Gold Copy is not available.';
export const TRANSLATION_NOT_AVAILABLE_TEXT = 'Translation is not available.';